import React, { useRef, useEffect } from 'react';
import { Card, Text, Group, Badge } from '@mantine/core';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';

const FullCalendarWidget = ({ selectedDate, setSelectedDate, events = [], onBreachClick }) => {
    const calendarRef = useRef(null);

    const handleDateClick = (arg) => {
        setSelectedDate(new Date(arg.date));
    };

    const handleEventClick = (clickInfo) => {
        if (clickInfo.event.start) {
            setSelectedDate(new Date(clickInfo.event.start));
        }
        const breach = clickInfo.event.extendedProps?.originalBreach;
        if (breach && onBreachClick) {
            onBreachClick(breach);
        }
    };

    useEffect(() => {
        if (calendarRef.current && selectedDate) {
            const calendarApi = calendarRef.current.getApi();
            calendarApi.gotoDate(selectedDate);
        }
    }, [selectedDate]);

    const headerToolbar = {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,dayGridWeek,dayGridDay'
    };

    return (
        <Card padding="md" radius="lg" withBorder style={{ height: '100%' }}>
            <Group justify="space-between" mb="md">
                <Text size="sm" fw={600} c="dimmed">
                    Calendario
                </Text>
            </Group>
            <div style={{ height: 'calc(100% - 80px)' }}>
                <FullCalendar
                    ref={calendarRef}
                    plugins={[dayGridPlugin, interactionPlugin]}
                    initialView="dayGridMonth"
                    headerToolbar={headerToolbar}
                    events={events}
                    dateClick={handleDateClick}
                    eventClick={handleEventClick}
                    height="100%"
                    locale="es"
                    firstDay={1} 
                    dayMaxEvents={3} 
                    moreLinkClick="popover"
                    eventDisplay="block"
                    displayEventTime={false}
                    eventContent={(eventInfo) => {
                        const mantineColor = eventInfo.event.extendedProps?.mantineColor || 'gray';
                        const title = eventInfo.event.title;
                        return (
                            <Badge
                                variant="light"
                                color={mantineColor}
                                size="sm"
                                radius={0}
                                tt={'capitalize'}
                                title={title}
                                style={{
                                    cursor: 'pointer',
                                    width: '100%',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: 'block',
                                    whiteSpace: 'nowrap',
                                    fontWeight: 500,
                                }}
                            >
                                {title}
                            </Badge>
                        );
                    }}
                    dayCellClassNames={(arg) => {
                        if (selectedDate && arg.date.toDateString() === selectedDate.toDateString()) {
                            return ['selected-date'];
                        }
                        return [];
                    }}
                    dayHeaderFormat={{ weekday: 'short' }}
                    titleFormat={{ year: 'numeric', month: 'long' }}
                    buttonText={{
                        today: 'Hoy',
                        month: 'Mes',
                        week: 'Semana',
                        day: 'Día'
                    }}
                />
            </div>
        </Card>
    );
};

export default FullCalendarWidget;